import FranceHotel1 from '../Assets/Images/france-hotel1.jpg';
import FranceHotel2 from '../Assets/Images/france-hotel2.jpg';
import FranceHotel3 from '../Assets/Images/france-hotel3.jpg';
import FranceHotel4 from '../Assets/Images/france-hotel4.jpg';
import FranceHotel5 from '../Assets/Images/france-hotel5.jpg';
import FranceHotel6 from '../Assets/Images/france-hotel6.jpg';

let ParisCityBreaksItems = [
    {
        id: 1,
        itemImage: FranceHotel1,
        itemTitle: 'Eiffel View Boutique Hotel',
        itemSubTitle: 'Paris, France',
        itemNights: '3 nights',
        itemPrice: '£599'
    },
    {
        id: 2,
        itemImage: FranceHotel2,
        itemTitle: 'Historic Château-Inspired Stay',
        itemSubTitle: 'Paris, France',
        itemNights: '3 nights',
        itemPrice: '£599'
    },
    {
        id: 3,
        itemImage: FranceHotel3,
        itemTitle: 'Classic Parisian Townhouse',
        itemSubTitle: 'Paris, France',
        itemNights: '2 nights',
        itemPrice: '£799'
    },
    {
        id: 4,
        itemImage: FranceHotel4,
        itemTitle: 'Modern Riverside Hotel',
        itemSubTitle: 'Paris, France',
        itemNights: '3 nights',
        itemPrice: '£399'
    },
    {
        id: 5,
        itemImage: FranceHotel5,
        itemTitle: 'Cozy Left Bank Retreat',
        itemSubTitle: 'Paris, France',
        itemNights: '2 nights',
        itemPrice: '£499'
    },
    {
        id: 6,
        itemImage: FranceHotel6,
        itemTitle: 'Grand Boulevard City Hotel',
        itemSubTitle: 'Paris, France',
        itemNights: '3 nights',
        itemPrice: '£299'
    }
];

export default ParisCityBreaksItems;
